export enum Routes {
  RemoteSupportRouter = '/remotesupport/*',
  RemoteSupportPage = 'users',
}
